import { BadgeOptions } from 'src/registry/types/badges';
import { userMessages } from 'src/features/users/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { MEMBERSHIP_STATUS } from 'src/features/users/utils/types';

export const statusOptions: BadgeOptions = {
    [MEMBERSHIP_STATUS.ACTIVE]: {
        label: userMessages.statusActive,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [MEMBERSHIP_STATUS.INACTIVE]: {
        label: userMessages.statusInactive,
        icon: ICON_MAP.X_MARK,
        theme: 'red',
    },
};
